// extracted by mini-css-extract-plugin
export var container = "_61-0";
export var infoButton = "_61-1";
export var label = "_61-3";
export var labelExpanded = "_61-4";
export var price = "_61-5";
export var priceExpanded = "_61-6";
export var title = "_61-2";